import { SchoolList } from '../../../components/school-list/school-list';
import Layout from '../../../layouts/layout';
import type { School } from '../../../types';

type SchoolsByPrefecturePageProps = {
  prefecture: string;
  schools: Array<School>;
};

export default function SchoolsByPrefecturePage(props: SchoolsByPrefecturePageProps) {
  const { schools, prefecture } = props;

  return (
    <Layout title={prefecture}>
      <SchoolList prefecture={prefecture} schools={schools} />
    </Layout>
  );
}
